var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRemoveIcon = function SvgRemoveIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.15.1-Setup-/-Location---default",
    transform: "translate(-1372.000000, -236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(256.000000, 226.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Action",
    transform: "translate(1076.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(40.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "close-circle",
    mask: "url(#mask-2)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.125,0 C3.64492188,0 0,3.64492188 0,8.125 C0,12.6050781 3.64492188,16.25 8.125,16.25 C12.6050781,16.25 16.25,12.6050781 16.25,8.125 C16.25,3.64492188 12.6050781,0 8.125,0 Z M11.0667969,10.1832031 C11.2314445,10.3396279 11.2982821,10.573056 11.2413769,10.7929181 C11.1844717,11.0127803 11.0127803,11.1844717 10.7929181,11.2413769 C10.573056,11.2982821 10.3396279,11.2314445 10.1832031,11.0667969 L8.125,9.00898437 L6.06679687,11.0667969 C5.82106919,11.3002524 5.43404309,11.2952973 5.19437291,11.0556271 C4.95470273,10.8159569 4.94974757,10.4289308 5.18320312,10.1832031 L7.24101562,8.125 L5.18320312,6.06679687 C4.94974757,5.82106919 4.95470273,5.43404309 5.19437291,5.19437291 C5.43404309,4.95470273 5.82106919,4.94974757 6.06679687,5.18320312 L8.125,7.24101562 L10.1832031,5.18320312 C10.4289308,4.94974757 10.8159569,4.95470273 11.0556271,5.19437291 C11.2952973,5.43404309 11.3002524,5.82106919 11.0667969,6.06679687 L9.00898437,8.125 L11.0667969,10.1832031 Z"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemoveIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove-icon.b3a480d4.svg";
export { ForwardRef as ReactComponent };